import { useEffect, useRef } from "react";

export const RadarCanvas = ({ className = "" }) => {
  const ref = useRef(null);

  useEffect(() => {
    const canvas = ref.current;
    const ctx = canvas.getContext("2d");
    let raf;
    let t = Math.PI * 0.5;

    const resize = () => {
      canvas.width = canvas.offsetWidth * window.devicePixelRatio;
      canvas.height = canvas.offsetHeight * window.devicePixelRatio;
    };
    resize();
    window.addEventListener("resize", resize);

    const draw = () => {
      t += 0.006;
      const w = canvas.width;
      const h = canvas.height;
      ctx.clearRect(0, 0, w, h);
      const cx = w * 0.7;
      const cy = h * 0.52;
      const maxR = Math.min(w, h) * 0.72;

      ctx.lineWidth = 1;
      for (let i = 1; i <= 5; i++) {
        ctx.beginPath();
        ctx.arc(cx, cy, (maxR / 5) * i, 0, Math.PI * 2);
        ctx.strokeStyle = `rgba(200, 16, 46, ${0.14 - i * 0.015})`;
        ctx.stroke();
      }

      ctx.strokeStyle = "rgba(255,255,255,0.05)";
      ctx.beginPath();
      ctx.moveTo(cx - maxR, cy);
      ctx.lineTo(cx + maxR, cy);
      ctx.moveTo(cx, cy - maxR);
      ctx.lineTo(cx, cy + maxR);
      ctx.stroke();

      for (let i = 0; i < 50; i++) {
        const a = t - i * 0.018;
        ctx.beginPath();
        ctx.moveTo(cx, cy);
        ctx.lineTo(cx + Math.cos(a) * maxR, cy + Math.sin(a) * maxR);
        ctx.strokeStyle = `rgba(200,16,46,${0.22 * (1 - i / 50)})`;
        ctx.stroke();
      }

      const blips = [
        [0.28, 0.18],
        [-0.42, 0.3],
        [0.08, -0.44],
        [-0.15, -0.2],
      ];
      blips.forEach((b, i) => {
        const phase = (Math.sin(t * 2.4 + i * 1.7) + 1) / 2;
        const bx = cx + b[0] * maxR;
        const by = cy + b[1] * maxR;
        ctx.beginPath();
        ctx.arc(bx, by, 3.5 + phase * 5, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(0,160,80,${0.75 - phase * 0.45})`;
        ctx.fill();
        ctx.beginPath();
        ctx.arc(bx, by, 10 + phase * 16, 0, Math.PI * 2);
        ctx.strokeStyle = `rgba(0,160,80,${0.25 * (1 - phase)})`;
        ctx.stroke();
      });

      raf = requestAnimationFrame(draw);
    };
    raf = requestAnimationFrame(draw);

    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("resize", resize);
    };
  }, []);

  return <canvas ref={ref} className={className} data-testid="hero-radar-canvas" />;
};
